
import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import {
    Link, useLocation,
} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

import appScreenshot from '../../assets/images/payroll.png';

import { connect } from 'react-redux';
import { Actions as CREATEACCOUNTACTIONS } from 'store/actions/createAccountActions';
import { Actions as WEBINARACTIONS } from 'store/actions/webinarActions';
import Team from 'components/team/Team'
import DarkScreenshotRight from '../uk/for/DarkScreenshotRight'
import LightScreenshotLeft from '../uk/for/LightScreenshotLeft'
import Security from 'components/security/Security'
import RegistrationForm from 'components/common/RegistrationForm'

import { format, addMinutes } from "date-fns";

import Vimeo from '@u-wave/react-vimeo';
import ReactPixel from 'react-facebook-pixel';
// import AddToCalendar from 'react-add-to-calendar';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import 'react-add-to-calendar/dist/react-add-to-calendar.css'
import { CheckIcon, XMarkIcon, CalendarDaysIcon, GlobeEuropeAfricaIcon, CurrencyPoundIcon, UserGroupIcon, ShieldCheckIcon, ScaleIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline'

import {
    CalculatorIcon,
    CalendarIcon,
    CloudArrowUpIcon,
    LockClosedIcon,
    ServerIcon,
    CheckCircleIcon,
    UserCircleIcon,
    MapPinIcon,
    ClipboardDocumentCheckIcon,
    DevicePhoneMobileIcon,
    ClockIcon,
    ChartBarIcon,
    CreditCardIcon,
    DocumentChartBarIcon,
    CloudIcon,
    CogIcon,
    ListBulletIcon,
    ShieldCheckIcon as ShieldCheckIconSolid, DocumentIcon, ChartPieIcon,
} from '@heroicons/react/20/solid'


import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import LoginForm from "../../components/login/LoginForm";
import SeoHeaders from "../../components/SeoHeaders";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const EMAILLIST = 11
const tags = {
    ukSignUp: 56
}

const title = "Payslips, Holidays and Timesheets for Employees",
    intro = "You want to get paid correctly. We Understand. Buddy is here to help your employer get your pay right. While we ensure easy access to your payslips, holidays and timesheets.",
    introCta = "Discover how Buddy can help make your life easier.",
    description = "UK Payroll has never been easier. With Buddy's cloud UK Payroll Software, you can get payroll done quickly and efficiently."
// intro: "Rediscover the Joy of Payroll",

const faqs = [
    {
        question: "How long does it take to implement Buddy, including the migration of existing clients?",
        answer:
            "Migration times can vary depending on the complexity of your data and the number of clients you have. For small bureaus it is usually a matter of hours or days, for larger bureaus much will depend on the quality of the data available from your current system and the availability of your team to assist with the migration. We have a team of experts who can help you with the migration process, reach out to our team so we can give a better indication based on your unique circumstances.",
    },
    {
        question: "What is the pricing model for Buddy?",
        answer:
            <>Buddy's pricing can be found in detail on the <Link to={"payroll-bureau/pricing"}>payroll bureau pricing page</Link>. These prices exclusively for qualified professionals with a registered institute who are offering a payroll service.</>,
    },
    {
        question: "What type of training and onboarding support does Buddy offer to new users?",
        answer:
            "We offer a range of training and onboarding options to suit your needs. From self-service resources to one-on-one training sessions, we're here to help you get up and running with Buddy as quickly as possible. Reach out to our team to discuss your requirements in more detail.",
    },
    {
        question: "Does Buddy integrate with other software?",
        answer:
            "Yes, Buddy integrates with a range of popular accounting software, HR systems, and other tools to streamline your payroll processes. You can view more information on our integrations page. If you have a specific integration in mind, reach out to our team to discuss your requirements.",
    },
    {
        question: "How frequently is the software updated to ensure compliance with the latest payroll regulations?",
        answer: "Buddy is updated regularly to ensure compliance with the latest payroll regulations. Our team closely monitors changes to legislation and updates the software accordingly. You can rest assured that Buddy will keep you compliant with the latest requirements.",
    },
    {
        question: "How are these updates managed and communicated to the users?",
        answer: "Our customer success team sends out an email to all our customers as soon as updates are completed, furthermore we also provide in-app notifications that would link to the detailed release notes.",
    },
    {
        question: "Can you provide more details on how multi-factor authentication is implemented?",
        answer: "Multi-factor authentication is a feature that can be enabled for the bureau and per client. This requires each user to set up their unique token using a device such as their phone by scanning a QR code on their first login. This ensures that even if a user's password is compromised, their account remains secure.",
    },
    {
        question: "Why is data stored in UK & EU Data Centers?",
        answer: "As part of our ISO27001 Audits we had identified an inherent risk in storing your data in a single region. Given the sensitivity of the data we store, we have decided to store your data in both the UK and EU data centers. This ensures that in case of a disaster we can recover your data from a different region.",
    },
    {
        question: "Can my data be stored only in the UK?",
        answer: "Given that the UK's data protection laws are now aligned with the EU's GDPR. We feel that the benefit of having your data stored in both the UK and EU data centers outweighs the risk of storing it in a single region. Furthermore, this restriction could also mean that certain features within Buddy would not otherwise be available. If you are an enterprise customer and this is something your IT team will not budge on please talk to us to discuss options.",
    },
    {
        question: "What is the historical uptime of the Buddy system?",
        answer: "Given that Buddy uses a serverless, or cloud-native architecture, we have a 99.99% uptime. This means that the system is available 99.99% of the time, with the remaining 0.01% being reserved for maintenance and updates. Due to the nature of the cloud, we are able to deploy the large majority of updates without any downtime.",
    },
    {
        question: "How does Buddy handle system outages or disruptions, especially during critical payroll processing periods?",
        answer: "In the unlikely event of a system outage, our team is on hand to resolve the issue as quickly as possible. We have a dedicated team of engineers who monitor the system and are alerted to any issues immediately. We also have a disaster recovery plan in place to ensure that your data is safe and secure.",
    },
    {
        question: "How customizable are the payroll and reporting features in Buddy?",
        answer: "Our standard reports are all generated using our reporting engine. You can use our custom report builder to choose which fields you would like in any new report.",
    },
    {
        question: "What level of access do clients have within the system?",
        answer: "By default clients will have no access to the system. While employees will only get access to their payslips. You are then able to invite users and provide distinct permissions. Most commonly clients are given access to employee data, payroll data entry and approval, reports as well as holiday management.",
    },
    {
        question: "How well does Buddy scale with the growth of a payroll bureau?",
        answer: "Buddy is designed to scale with your business. Whether you're a small bureau or a large enterprise, Buddy can handle your payroll needs. Our cloud-native architecture ensures that the system can grow with your business, providing the flexibility and scalability you need.",
    },
    {
        question: "What are the limitations, if any, in terms of processing capacity or client numbers?",
        answer: "Buddy is designed to handle a large number of clients and employees. Our largest single employer currently employs thousands of people. When dealing with single entities that have large numbers of employees generation of multi-page PDF reports may take proportionally longer. You are however notified when these are complete so you can continue working on something else.",
    },


    // More questions...
]

const forBlocks = [
    {
        for: "Help your boss pay you right",
        title: "Effective Collaboration",
        backgroundColor: "employee",
        textColor: "employee",
        description: "In order to pay you correctly, your employer needs your help. At the very least they need to know when you're taking days off. Based on your work they also likely need other information.",
        mobileImage: {
            src: 'assets/images/[country]/mobile-app-leave.png',
            alt: "Product screenshot",
        },
        features: [
          {
            name: 'Personal Information',
            description:
              'Check and update your personal information from the Buddy App, to ensure your employer has the correct details.',
            icon: UserCircleIcon,
          },
          {
            name: 'Holidays',
            description: 'Book your holidays early, so your employer can plan and calculate your Holiday Pay correctly.',
            icon: MapPinIcon,
          },
          {
            name: 'Time',
            description: "If you're asked to clock-in make sure you do so, via the app or punch clock as indicated by the employer.",
            icon: CheckCircleIcon,
          },
      ]
    },

  {
    "for": "Absences",
    "title": "Holiday Entitlement & Pay",
    backgroundColor: "employee",
    textColor: "employee",
    "description": "Whenever you take paid time off, or are sick, your employer needs to know. Buddy makes it easy for you to request time off and for your employer to approve it.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Team leader dashboard screenshot"
    },
    "features": [
      {
        "name": "Holiday Application",
        "description": "Apply for days off easily through the mobile app, and get notified when your request is approved.",
        "icon": DevicePhoneMobileIcon
      },
      {
        "name": "Holiday Balances",
        "description": "View your available holiday balance right when you are making your applications. This way you're never caught out",
        "icon": DevicePhoneMobileIcon
      },
      {
        "name": "Sick & Other Absences",
        "description": "When applying for other absences you can upload a sick note or other relevant documents to ensure your employer has all the information they need.",
        "icon": CalendarIcon
      },
    ]
  },

  {
    "for": "Understand your pay",
    "title": "Payslips that are easy to understand",
    backgroundColor: "employee",
    textColor: "employee",
    "description": "If you cannot understand your payslip, how can you be sure you're being paid correctly? Buddy makes it easy for you to understand your payslip.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Payroll dashboard screenshot"
    },
    "features": [
      {
        "name": "Interactive Payslip",
        "description": "On Buddy's mobile app your payslip also includes graphs and charts to help you understand your pay. Additionally all pay items are split out to help you understand how your pay is calculated.",
        "icon": CalculatorIcon
      },
      {
        "name": "Mid-month raises",
        "description": "Ever tried to figure out how your mid month raise was worked out? We make sure that your payslip is split into two parts; one before the raise, and another part after. This way it is easier to understand.",
        "icon": CalendarIcon
      },
      {
        "name": "Totals to Date",
        "description": "We show you totals to date, to ensure you can easily see how much you've earned this tax year.",
        "icon": ClipboardDocumentCheckIcon
      }
    ]
  },
  {
    "for": "Data Security",
    "title": "Is my data safe?",
    backgroundColor: "employee",
    textColor: "employee",
    "description": "We know nothing is more important than your personal data. That's why we've invested heavily in ensuring your data is safe and secure.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
        width: 929,
        height: 519,
      "alt": "IT dashboard screenshot"
    },
    "features": [
      {
        "name": "ISO 27001",
        "description": "This industry leading security certification ensures that the Buddy team has the right security processes in place. This certification is done with external auditors that visit our premises every year. ISO 27001 is more comprehensive when compared to CyberEssentials.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "System Penetration Testing",
        "description": "On a regular basis we invite security researches to attempt to hack into our system. This empowers us to stay ahead of hackers and identify potential risks before its too late.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "Encryption",
        "description": "All the data you or your employer share or store with Buddy is encrypted with AES256-grade encryption both in transit and at rest.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "Multi-Factor Authentication",
        "description": "If you're concerned that someone will be able to access your account, Enable MFA to ensure that your credentials cannot be compromised without also having access to a physical device.",
        "icon": CloudIcon
      },
      {
        "name": "UK & EU Data Centres",
        "description": "In order to make sure that your employer can calculate your pay no matter what, we store your data in multiple locations in the UK and Europe. This ensures that even if one data centre goes down, your data is still available.",
        "icon": ShieldCheckIconSolid
      },
    ]
  },
  {
    "for": "Finding Help",
    "title": "Getting Help when you need it",
    backgroundColor: "employee",
    textColor: "employee",
    "description": "As an Employee your employer should always be your first point of contact if you have problems with your pay. If you are however having technical issues, Buddy is here to help.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Management dashboard screenshot"
    },
    "features": [
      {
        "name": "Detailed Support Articles",
        "description": "Looking for support out of hours? That's where our support bot will guide you to pre-existing detialed artilces to get you unstuck. If that doesn't work, leave a message.",
        "icon": DocumentIcon
      },
      {
        "name": "Video Tutorials",
        "description": "Alongside our support articles we also provide video tutorials, these show you step by step what you have to do. This way you don't need to ask your employer to remind you every time.",
        "icon": DocumentIcon
      },
      {
        "name": "Amazing Humans",
        "description": "While Generative AI is taking over the world, we don't yet trust it to ensure that your payroll is correct. That's why we have a team of amazing humans that respond to every query from your employer.",
        "icon": ChartPieIcon
      }
    ]
  }
]

function UkLanding({
    userInList,
    contactInList,
    saveLead,
    profile,
}) {

    const location = useLocation()

    const countryCode = location.pathname.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

    useEffect(() => {
        // load initial data required for anywhere
        if (profile && profile.email) {
            contactInList({
                email: profile.email,
                // list: EMAILLIST
            })
        }
    }, [profile && profile.email]);


    return (

        <React.Fragment>

            <SeoHeaders
                country={country}
                title={title}
                description={intro}
            />

            <main className="pt-8 sm:pt-16 md:pt-20 lg:pb-24 pb-8 sm:pb-16 md:pb-20 lg:pb-24 bg-employee-900">
                <div className="mx-auto max-w-screen-xl">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                            <div>
                                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    <span>Payslips, Holidays and Timesheets </span>
                                    <br />
                                    <span className="text-orange-400">for Employees</span>
                                </h1>
                                <p className="mt-3 text-base text-gray-300 sm:mt-5 lg:text-lg">
                                    {intro}
                                </p>

                                  <div className="mt-10 flex gap-x-6">
                                    <a href="#" className="text-sm font-semibold leading-6 text-white">
                                        {introCta} <span aria-hidden="true">↓</span>
                                    </a>
                                  </div>
                            </div>
                        </div>
                        {<div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6" id={"leadForm"}>
                            <LoginForm/>
                        </div>}
                    </div>
                </div>
            </main>


            {/*<div class="bg-white py-24 sm:py-32">
              <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl lg:text-center">
                  <p class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Buddy: Your Comprehensive Payroll Companion</p>
                  <p class="mt-6 text-lg leading-8 text-gray-600">In the world of payroll, details matter. But so do people. At Buddy, we've crafted a solution that balances both, ensuring that every stakeholder, from employees to IT teams, feels valued and empowered. Our platform isn't just about numbers; it's about nurturing relationships, streamlining processes, and building trust. Dive in to discover how Buddy becomes an integral part of your team, simplifying complexities and amplifying efficiencies.</p>

                  <h2 class="mt-12 text-lg font-semibold leading-7 text-orange-600">Why Buddy?</h2>
                </div>
                <div class="mx-auto mt-10 max-w-2xl sm:mt-20 lg:mt-20 lg:max-w-4xl">
                  <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                      {painpoints.map((feature) => (
                            <div key={feature.name}  class="relative pl-16">
                              <dt class="text-base font-semibold leading-7 text-gray-900">
                                <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-orange-600">

                                    {feature.icon}

                                </div>
                                {feature.name}
                              </dt>
                              <dd class="mt-2 text-base leading-7 text-gray-600">{feature.description}</dd>
                            </div>

                        ))}
                  </dl>
                </div>
                <div class="mx-auto mt-12 max-w-2xl lg:text-center">
                    <h2 className="text-lg font-extrabold text-gray-900">Every organization is a complex web of interactions, decisions, and processes. See how Buddy seamlessly fits into each facet, enhancing productivity and ensuring satisfaction.</h2>
                </div>
              </div>
            </div>*/}

            {forBlocks.map((block,index) => (
                index % 2 !== 0 ? <DarkScreenshotRight key={block.for} content={block}  country={country}/> : <LightScreenshotLeft key={block.for} content={block}  country={country}/>
            ))}

            <div className="bg-orange-600">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                    <div className="bg-white shadow-xl rounded-lg overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
                        <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
                            <div className="lg:self-center">
                                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                                    <span className="block">Discover, Buddy</span>
                                    <span className="block">Your new Payroll Companion</span>
                                </h2>
                                <p className="mt-4 text-lg leading-6 text-gray-900">
                                    Buddy does all the heavy lifting, so you can spend as little time as possible on your payroll, knowing that everything’s just how it should be.
                                </p>
                                <NavHashLink to="#leadForm"
                                    className="mt-8 bg-orange-600 border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-white hover:bg-orange-50"
                                >
                                    Discover Buddy
                                </NavHashLink>
                            </div>
                        </div>
                        <div className="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
                            <img
                                className="transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                                src={appScreenshot}
                                alt="App screenshot"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-gray-50">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
                    <div className="max-w-4xl mx-auto divide-y-2 divide-gray-200">
                        <h2 className="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">Frequently asked questions</h2>
                        <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-6 sm:space-y-0 lg:gap-x-10 pt-6">
                            {faqs.map((faq) => (
                                <Disclosure as="div" key={faq.question}>
                                    {({ open }) => (
                                        <>
                                            <dt className="text-md">
                                                <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                                                    <span className="font-medium text-gray-900">{faq.question}</span>
                                                    <span className="ml-6 h-7 flex items-center">
                                                        <ChevronDownIcon
                                                            className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </Disclosure.Button>
                                            </dt>
                                            <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                                <p className="text-sm text-gray-500">{faq.answer}</p>
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>

            <Team />

        </React.Fragment>

    );
}

const mapStateToProps = (state) => {

    // const {
    //   myAgreements,
    // } = state.my

    const profile = state && state.my && state.my.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

    const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find(item => item == EMAILLIST)

    const webinar = state.webinar

    const userSubscribedForWebinar = webinar && state.createAccount && state.createAccount.webinars && state.createAccount.webinars.find(item => item == webinar.webinarID)

    return {
        webinar,
        userInList,
        userSubscribedForWebinar,
        profile
        // showSidebar: state.sidebar.show,
        // loggedIn: state.my.profile ? true : false,
    }
}

const mapDispatchToProps = dispatch => ({
    contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
    saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
    addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
    setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar)),
    // getProfile: () => dispatch(MYACTIONS.getProfile()),
    // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
    // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UkLanding)